import { Component, OnInit, trigger, state, style, transition, animate, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'cm-mentions-legales',

    template: `
        <div class="ecran-mentions-legales text-justify" 
            [@afficherCacherEcran]="etatEcran">

            <div class="cadre-fermer" (click)="fermer()"> <img class="img image-fermer" src="./assets/images/croix.png"/> </div>

            <div class="cadre-defilement">

                <h3>Mentions légales</h3>
                <hr>
                <p>
                La loi n°2004-575 du 21 juin 2004, dite loi sur la confiance dans l’économie numérique (LCEN), transposant la directive 
                communautaire 2000/31/CE du Parlement européen et du Conseil du 8 juin 2000, dite directive sur le commerce électronique, 
                complétée par le décret n°2007-750 du 9 mai 2007 relatif au registre du commerce et des sociétés et modifiant le code de commerce, 
                et modifiée par la loi n°2008-3 du 3 janvier 2008, dresse une liste des informations légales à faire figurer sur les sites web.
                </p>

                <h3>L’Éditeur</h3>
                <hr>
                <p>
                Le site La Carte Mariale du monde est édité par:
                </p>
                <p>
                MdN Productions SARL au capital de €75 000.
                </p>
                
                <p>
                226, rue Lecourbe, 75015 Paris, France.
                </p>
                <p>
                Contact: admin@mdn-productions.com
                </p>

                <h3>L’Hébergeur</h3>
                <hr>
                <p>
                Le site La Carte Mariale du monde est hebergé par OVH.
                </p>

            </div>

        </div>
    `,

    styles: [`
        .ecran-mentions-legales {
            position: absolute;
            top: 0;
            left: 60vw;
            width: calc(40vw - 60px);
            height: calc(100vh - 50px);
            background-color: white;
            border: 1px solid lightgray;
        }
        .cadre-defilement {
            padding: 30px 30px 30px 45px;
            height: calc(100vh - 50px - 50px);
            overflow-y: auto;
        }
        .cadre-fermer {
            height: 50px;
        }
        .image-fermer {
            position: relative;
            top: 10px;
            left: calc(100% - 40px);
            width: 25px;
            height: 25px;
            cursor: pointer;
        }
        h3 {
            margin: 40px 0 15px 0;
        }

        @media (max-width: 800px), (max-height: 700px) { 
            .ecran-mentions-legales {
                left: 0;
                width: 100vw;
                height: 100vh;
                padding: 30px 20px 30px 20px;
            }
        }
    `],

     animations: [
        trigger('afficherCacherEcran', [
        state('visible', style({
        transform: 'translateX(0) scale(1, 1)'
        })),
        state('invisible', style({
            transform: 'translateX(100%) scale(0, 1)'
        })),
        transition('visible => invisible', animate('400ms ease-in-out')),
        transition('invisible => visible', animate('400ms ease-in-out'))
        ]),
    ]
})

export class MentionsLegalesComponent implements OnInit {
    @Input() etatEcran: string;
    @Output() fermerEcran: EventEmitter<any> = new EventEmitter();

    constructor() {}

    ngOnInit() {
    }

    fermer() {
       this.fermerEcran.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/mentions-legales.component.ts